import { EmptyState } from '@/components/ui';

/** Desktop placeholder shown in the chat pane before a room is picked. */
export default function NoConversation() {
  return (
    <div style={{ margin: 'auto' }}>
      <EmptyState
        illustration="/assets/illustrations/chat.png"
        title="Sélectionnez une conversation"
        text="Choisissez une conversation à gauche pour afficher les messages."
      />
    </div>
  );
}
